import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  Typography,
  Tag,
  Row,
  Col
} from "antd";
import { TableComponent } from "../Master/CommonComponents";
import Heading from "../../components/Heading";
//import search_icon from "../../assests/images/search-icon.svg";
import "./style.scss";

const { Text } = Typography;

const PincodeSearch = () => {
  const location = useLocation();
  const navigate = useNavigate();
  //const [searchData, setSearchData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  //const [searchText, setSearchText] = useState("");
  const [cityText, setCityText] = useState("");
  const [stateText, setStateText] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
  });

  // Extract data from navigation state
  useEffect(() => {
    const { pincodeData, pincode } = location.state || {}; // Extract pincode here
  
    // 🔥 CLEAR previous table data first
    setFilteredData([]);
    setPagination(prev => ({
      ...prev,
      current: 1,
      total: 0,
    }));
  
    if (!pincodeData) return;
  
    // Parse the new response structure { state, data: { city, state, serviceDetails: [] } }
    const actualData = pincodeData?.data || {};
    const serviceDetails = actualData.serviceDetails || [];
    
    setCityText(actualData.city?.toUpperCase() || "----");
    setStateText(actualData.state?.toUpperCase() || "----");
  
    if (Array.isArray(serviceDetails)) {
      const mappedData = serviceDetails.map((item, index) => ({
        key: index,
        hubId: `${pincode}-${index}`, // Use pincode variable
        name: item.hub_name || "----",
        cpName: item.serviceType?.toUpperCase() || "NA",
        pincodeType: item.serviceable ? "SERVICABLE" : "NON-SERVICABLE",
      }));
  
      setFilteredData(mappedData);
      setPagination(prev => ({
        ...prev,
        total: mappedData.length,
      }));
    }
  }, [location.state]);
  

  // Filter data based on search criteria
  /*useEffect(() => {
    let filtered = [...searchData];

    // Text search
    if (searchText) {
      filtered = filtered.filter(item =>
        item.areaName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.cpName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.hubName.toLowerCase().includes(searchText.toLowerCase()) ||
        item.city.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    setFilteredData(filtered);
    setPagination(prev => ({
      ...prev,
      total: filtered.length,
      current: 1
    }));
  }, [searchData, searchText]);*/



  const pincode = location.state?.pincode || "";

  // Table columns for the main table
  const columns = [
    {
      title: "No.",
      key: "index",
      width: 60,
      align: "center",
      fixed: "left",
      render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Hub Name",
      dataIndex: "name",
      key: "name",
      align: "center",
      sorter: true,
      width: 150,
      render: (text) => <Text style={{ fontSize: "14px" }}>{text || "NA"}</Text>,
    },
    {
      title: "Service Type",
      dataIndex: "cpName",
      key: "cpName",
      align: "center",
      sorter: true,
      width: 200,
      render: (text) => <Text style={{ fontSize: "14px" }}>{text || "NA"}</Text>,
    },
    {
      title: " Serviceable Pincode",
      dataIndex: "pincodeType",
      key: "pincodeType",
      sorter: true,
      align: "center",
      width: 120,
      fixed: "right",
      render: (text) => (
        <Tag
          color={text === "SERVICABLE" ? "#C5F3D9" : "#FFE6E6"}
          style={{ color: "#475467", borderRadius: "10px" }}
        >
          {text || "NA"}
        </Tag>
      ),
    },
  ];

  // Custom back handler
  const goBackToPrevScreen = () => {
    if (window.history.length <= 1) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  // Handle table change for pagination, sorting, etc.
  const handleTableChange = (newPagination) => {
    setPagination(newPagination);
  };

  return (
    <>
      <div className="p-2-tab">
        <Heading title="Pincode Search" showBack={true} goBack={goBackToPrevScreen} />

        {/* Main Summary Card */}
        <Card
          style={{ borderRadius: 10, marginBottom: 20, marginTop: 20 }}
          bodyStyle={{ padding: 20 }}
        >
          <div className="space-between-start">
            <Row gutter={[16, 16]} align="middle">
              <Col xs={24}>
                <div style={{ display: "flex", alignItems: "center", gap: "50px", flexWrap: "nowrap" }}>
                  <div>
                    <Text strong style={{ fontSize: "18px" }}>{pincode}</Text>

                  </div>

                  <Text strong style={{ fontSize: "14px" }}>
                    {cityText}
                  </Text>
                  <Text strong style={{ fontSize: "14px" }}>
                    {stateText}
                  </Text>
                </div>
              </Col>
            </Row>
          </div>
        </Card>
      </div>

      {/* Main Data Table */}
      <div className="container">
        <TableComponent
          columns={columns}
          dataSource={filteredData}
          loading={false}
          pagination={pagination}
          onChange={handleTableChange}
          rowKey={(record, index) => `${record.hubId}-${index}`}


        />
      </div>
    </>
  );
};

export default PincodeSearch; 
